/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './template-schedule.reducer';

export const TemplateScheduleDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const templateScheduleEntity = useAppSelector(state => state.templateSchedule.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="templateScheduleDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.templateSchedule.detail.title">TemplateSchedule</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.templateSchedule.id">Id</Translate>
            </span>
          </dt>
          <dd>{templateScheduleEntity.id}</dd>
          <dt>
            <span id="dose">
              <Translate contentKey="tinyMedicRestApp.templateSchedule.dose">Dose</Translate>
            </span>
          </dt>
          <dd>{templateScheduleEntity.dose}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.templateSchedule.active">Active</Translate>
            </span>
          </dt>
          <dd>{templateScheduleEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.templateSchedule.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{templateScheduleEntity.cursor}</dd>
          <dt>
            <span id="lastUpdated">
              <Translate contentKey="tinyMedicRestApp.templateSchedule.lastUpdated">Last Updated</Translate>
            </span>
          </dt>
          <dd>{templateScheduleEntity.lastUpdated}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.templateSchedule.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{templateScheduleEntity.microSec}</dd>
          <dt>
            <span id="timestampEntry">
              <Translate contentKey="tinyMedicRestApp.templateSchedule.timestampEntry">Timestamp Entry</Translate>
            </span>
          </dt>
          <dd>{templateScheduleEntity.timestampEntry}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.templateSchedule.medicine">Medicine</Translate>
          </dt>
          <dd>{templateScheduleEntity.medicine ? templateScheduleEntity.medicine.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.templateSchedule.schedule">Schedule</Translate>
          </dt>
          <dd>{templateScheduleEntity.schedule ? templateScheduleEntity.schedule.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.templateSchedule.medication">Medication</Translate>
          </dt>
          <dd>{templateScheduleEntity.medication ? templateScheduleEntity.medication.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/template-schedule" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/template-schedule/${templateScheduleEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default TemplateScheduleDetail;
